export class Sorting {
  private readonly defaultValues: {column: string, direction: 'asc' | 'desc'};

  column: string;
  direction: 'asc' | 'desc';

  constructor(values: Partial<{column: string, direction: 'asc' | 'desc'}> = {}) {
    const {column = 'id', direction = 'asc'} = values;
    this.column = column;
    this.direction = direction;

    this.defaultValues = {column, direction};
    Object.defineProperty(this, 'defaultValues', {
      enumerable: false,
    });
  }

  loadFromQuery(query: Record<string, any>) {
    for (const key in this) {
      this[key] = query[key];
    }
  }

  buildSearchParams(searchParams: URLSearchParams) {
    for (const key in this) {
      searchParams.append(key, String(this[key] || this.defaultValues[key as 'column' | 'direction']));
    }
    return searchParams;
  }
}
